import React from 'react';
import HomeAllProductsSection from './HomeAllProductsSection';
import HomeGenderSection from './HomeGenderSection';
import HomeHero from './HomeHero';
import HomeTypeSection from './HomeTypeSection';
import useHomeProductTypes from './useHomeProductTypes';
import './HomePageShared.scss';
import './homePage.scss';

const HomePage = () => {
  const productTypes = useHomeProductTypes();

  return (
    <div className="home-container">
      <HomeHero />
      <HomeTypeSection productTypes={productTypes} />
      <HomeGenderSection />
      <HomeAllProductsSection />
    </div>
  );
};

export default HomePage;
